import { Controller } from "@hotwired/stimulus"

// Toggles photos layout (large grid, small grid, list) without reloading.
// Persists choice in cookie and URL so it survives navigation.
// Valid views come from the server via data-photos-view-valid-views-value (single source of truth).

export default class extends Controller {
  static targets = ["container", "viewInput", "viewButton"]
  static values = { validViews: { type: Array, default: [] } }

  selectView(event) {
    const view = event.currentTarget.getAttribute("data-view")
    if (!view || !this.validViewsValue.includes(view)) return

    if (this.hasContainerTarget) {
      const container = this.containerTarget
      this.validViewsValue.forEach((v) => container.classList.remove(`photos__list--${v}`))
      container.classList.add(`photos__list--${view}`)
    }

    this.viewButtonTargets.forEach((btn) => {
      const isSelected = btn.getAttribute("data-view") === view
      btn.classList.toggle("selected", isSelected)
      btn.setAttribute("aria-pressed", isSelected)
    })

    if (this.hasViewInputTarget) {
      this.viewInputTarget.value = view
    }

    const url = new URL(window.location.href)
    url.searchParams.set("view", view)
    window.history.replaceState({}, "", url)

    const secureAttr = window.location.protocol === "https:" ? "; Secure" : ""
    document.cookie = `photos_view=${view}; path=/; max-age=31536000; SameSite=Lax${secureAttr}`
  }
}
